import React, { type FC } from 'react'

import { useIntl } from 'react-intl'
import { useRecoilCallback } from 'recoil'

import {
  Flex,
  LINK_VARIANT_DEFAULT,
  Link,
  TEXT_VARIANT_STANDARD,
  TITLE_VARIANT_XL,
  Text,
  Title,
} from 'mailup-web-components'

import IconChevronsRight from 'Components/icons/IconChevronsRight'

import { panelConfigColumnsCloseCallback } from 'Pages/RecipientsList/recoil/callbacks/configColumns'

const PanelConfigColumnsHeader: FC = () => {
  const intl = useIntl()

  const handleClose = useRecoilCallback(panelConfigColumnsCloseCallback, [])

  return (
    <Flex flexDirection="column" gap="16px">
      <Flex alignItems="center" gap="16px">
        <Link
          variant={LINK_VARIANT_DEFAULT}
          onClick={handleClose}
          data-mu-test="close-side-panel"
          data-tip={intl.formatMessage({
            id: 'Load.RecipientsList.PanelCloseTooltip',
          })}
        >
          <IconChevronsRight width="14px" height="14px" />
        </Link>
      </Flex>

      <Title variant={TITLE_VARIANT_XL} overflowWrap="anywhere">
        {intl.formatMessage({ id: 'Load.RecipientsList.ActionConfigColumns' })}
      </Title>

      <Text variant={TEXT_VARIANT_STANDARD}>
        {intl.formatMessage({
          id: 'Load.RecipientsList.ModalConfigColumnsIntro',
        })}
      </Text>
    </Flex>
  )
}

export default PanelConfigColumnsHeader
